import styled from "styled-components";
export const DataPickerStyle = styled.div`
  a {
    text-decoration: none !important;
  }

  label {
    font-size: 14px;
    margin: 6px 0px;
  }
  input {
    display: block !important;
    width: 100% !important;
    padding: 0.375rem 0.75rem !important;
    font-size: 1rem !important;
    font-weight: 400 !important;
    line-height: 1.5 !important;
    color: #212529 !important;
    background-color: #fff !important;
    background-clip: padding-box !important;
    border: 1px solid #ced4da !important;
    appearance: none !important;
    border-radius: 0.25rem !important;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
    height: unset !important;
    text-align: right !important;
  }
  .clearButton {
    right: unset !important;
    left: 10px !important;
    top: 46% !important;
  }
`;
